import React, { useState } from 'react';
import './reviewsubmit.css';

const ReviewSubmit = () => {
  const [userName, setUserName] = useState('');
  const [reviewMessage, setReviewMessage] = useState('');
  const [rating, setRating] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleUserNameChange = (e) => {
    setUserName(e.target.value);
  };

  const handleReviewMessageChange = (e) => {
    setReviewMessage(e.target.value);
  };

  const handleRatingChange = (value) => {
    setRating(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  return (
    <div className='heading-0'>
    <h2>Submit Your Reviews</h2>
    <div className="reviewsubmitcontainer">
      {!isSubmitted ? (
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="userName">Your Name:</label>
            <input
              type="text"
              id="userName"
              value={userName}
              onChange={handleUserNameChange}
              required
            />
          </div>
          <div>
            <label htmlFor="reviewMessage">Review:</label>
            <textarea
              id="reviewMessage"
              value={reviewMessage}
              onChange={handleReviewMessageChange}
              required
            ></textarea>
          </div>
          <div>
            <label>Rating:</label>
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                onClick={() => handleRatingChange(index + 1)}
                style={{ cursor: 'pointer', color: index < rating ? 'gold' : 'gray' }}
              >
                ★
              </span>
            ))}
          </div>
          <button type="submit">Submit Review</button>
        </form>
      ) : (
        <p>Your review has been submitted and will be published soon.</p>
      )}
    </div>
    </div>
  );
};

export default ReviewSubmit;